const config = {
  "locations": {
    "carParking": {
      "ABZ": "Aberdeen",
      "BHD": "Belfast City (George Best)",
      "BHX": "Birmingham",
      "BOH": "Bournemouth",
      "BRS": "Bristol",
      "CWL": "Cardiff",
      "DSA": "Doncaster-Sheffield (Robin Hood)",
      "DUB": "Dublin",
      "MME": "Durham Tees Valley",
      "EMA": "East Midlands",
      "EDI": "Edinburgh",
      "EXT": "Exeter",
      "LGW": "Gatwick",
      "GLA": "Glasgow International",
      "PIK": "Glasgow Prestwick",
      "LHR": "Heathrow",
      "HUY": "Humberside ",
      "INV": "Inverness",
      "LBA": "Leeds Bradford",
      "LPL": "Liverpool",
      "LCY": "London City",
      "LTN": "Luton",
      "MAN": "Manchester",
      "NCL": "Newcastle",
      "NWI": "Norwich",
      "SNN": "Shannon",
      "SOU": "Southampton",
      "SEN": "Southend",
      "STN": "Stansted"
    },
    "hotels": {
      "ABZ": "Aberdeen",
      "BHX": "Birmingham",
      "BOH": "Bournemouth",
      "BRS": "Bristol",
      "CWL": "Cardiff",
      "DSA": "Doncaster-Sheffield (Robin Hood)",
      "DUB": "Dublin",
      "MME": "Durham Tees Valley",
      "EMA": "East Midlands",
      "EDI": "Edinburgh",
      "EXT": "Exeter",
      "LGW": "Gatwick",
      "GLA": "Glasgow International",
      "PIK": "Glasgow Prestwick",
      "LHR": "Heathrow",
      "LBA": "Leeds Bradford",
      "LPL": "Liverpool",
      "LCY": "London City",
      "LTN": "Luton",
      "MAN": "Manchester",
      "NCL": "Newcastle",
      "NWI": "Norwich",
      "SOU": "Southampton",
      "SEN": "Southend",
      "STN": "Stansted"
    },
    "terminals": {
      "LHR": {
        "Terminal 2": "2",
        "Terminal 3": "3",
        "Terminal 4": "4",
        "Terminal 5": "5"
      },
      "MAN": {
        "Terminal 1": "1",
        "Terminal 2": "2",
        "Terminal 3": "3"
      },
      "LGW": {
        "North": "N",
        "South": "S"
      }
    }
  },
  "RoomTypes": {
    "D20": "Double - 2 adults",
    "T20": "Twin - 2 adults",
    "T11": "Twin - 1 adult 1 child",
    "S10": "Single - 1 adult",
    "T12": "Triple - 1 adult 2 children",
    "T21": "Triple - 2 adults 1 child",
    "T30": "Triple - 3 adults",
    "F13": "Family - 1 adult 3 children",
    "F22": "Family - 2 adults 2 children",
    "F23": "Family - 2 adults 3 children",
    "F31": "Family - 3 adults 1 child",
    "F32": "Family - 3 adults 2 children"
  },
  "sortOptions": {
    "carParking": {
      "": "Recommended",
      "price": "Price",
      "distance": "Distance"
    },
    "hotels": {
      "": "Recommended",
      "price": "Price",
      "distance": "Distance",
      "star_rating": "Star Rating"
    }
  },
  "domainSettings": {
    "scheme": "https",
    "language": "UK",
    "domain": "www.airparks.co.uk",
    "assets": "//staticsg.airparks.co.uk",
    "assetsLocal": "",
    "assetsLive": "//staticsg.airparks.co.uk",
    "contentStaticServer": "//static1.airparks.co.uk",
    "siteCode": "APS-HAR-1",
    "defaultParkingBanner": "/images/airparks-bootstrap/busbanner.jpg",
    "assetVersion": 1750951061796,
    "trackerPath": "/hx-tracker/tracker-v5-latest.min.js"
  },
  "reviews": {
    "defaultLimit": 5,
    "defaultMaxLength": 600,
    "defaultStartDate": "-1095"
  },
  "settings": {
    "rpcGatewayBase": "https://seo-rpc-gateway.dock-yard.io/",
    "variationCookie": "variation",
    "priceFormat": "£",
    "brand": "AP",
    "cookieExpiryDays": 90,
    "cookieDomain": ".airparks.co.uk",
    "soapiBase": "//static1.airparks.co.uk/datafeeds/soapi/",
    "locationReviewsRoute": "reviews",
    "locationPricesRoute": "prices",
    "locationTableRoute": "location?prodlibSpecific=address,latitude,longitude,on_airport,transfer_time,meet_and_greet,keep_keys,name,tripappcarparkname,tripapphotelname,tripappaddonname,star_rating,_prodcode,tripappimages,logo,prodlogo,seo_page_product_name,seo_page_transfer_time&renewCache",
    "docsAPIEndpoint": "https://static1.holidayextras.com/datafeeds/soapi/hapi-lookup?hapiRoute=info/docs/html&agent=WEB1",
    "docsAPIEndpointJSON": "https://static1.holidayextras.com/datafeeds/soapi/hapi-lookup?hapiRoute=info/docs&agent=WEB1",
    "customerRelationsEmail": "hasslefree@holidayextras.com",
    "pluginsExportDir": "../config/exports",
    "mPulseKey": "RXT7L-ARSSF-38NC9-2C56N-JDHYK",
    "operatingTimes": {
      "weekdayOpeningTime": "8pm",
      "weekdayClosingTime": "11pm",
      "weekendOpeningTime": "8:30am",
      "weekendClosingTime": "8pm"
    }
  },
  "agents": {
    "main": "WX425",
    "search": "WW783",
    "responsys": "WK820",
    "switchboardNumber": "0871 360 2603",
    "fallBackPhoneNumber": "0871 360 2603"
  },
  "gtmTag": {
    "id": "GTM-KSHCWX"
  },
  "formSettings": {
    "language": "en",
    "dateFormat": "DD/MM/YY",
    "parkingAction": "//trip.holidayextras.co.uk/parking/c/availability",
    "hotelAction": "//trip.holidayextras.co.uk/hotels2008/c/availabilityV5",
    "defaultParkingLocation": "LGW",
    "defaultHotelLocation": "LGW",
    "defaultRoomType": "D20",
    "defaultArrivalTime": "1200",
    "defaultDepartTime": "1300",
    "method": "get",
    "ruleset": "airparks",
    "flightSearch": "https://flight.dock-yard.io/",
    "parkingFilters": [
      {
        "name": "filter_meetandgreet",
        "text": "Meet & Greet"
      },
      {
        "name": "filter_parkandride",
        "text": "Park & Ride"
      }
    ],
    "engineOptions": {
      "ho": {
        "canSellFlag": "HotelBookings",
        "productClass": "ho",
        "product": "ho",
        "text": "Airport Hotels",
        "mobileLink": "/airport-hotels.html"
      },
      "hcp": {
        "canSellFlag": "HotelParking",
        "productClass": "hcp",
        "product": "hcp",
        "text": "Airport Hotels with parking",
        "mobileLink": "/airport-hotels.html"
      },
      "cp": {
        "canSellFlag": "CarParkBookings",
        "productClass": "cp",
        "product": "cp",
        "text": "Airport Parking",
        "mobileLink": "/airport-parking.html"
      }
    },
    "hotelLabels": {
      "ho": {
        "startDate": "Hotel check-in",
        "endDate": "Return date",
        "startDateHomepageTest": "Check in (1 night)",
        "endDateHomepageTest": "Collect car"
      },
      "hcp": {
        "ppts": {
          "startDate": "Parking from",
          "endDate": "Hotel check-in",
          "startDateHomepageTest": "Parking from",
          "endDateHomepageTest": "Check in (1 night)"
        },
        "nonPpts": {
          "startDate": "Hotel and Parking check-in",
          "endDate": "Collect car on",
          "startDateHomepageTest": "Check in (1 night)",
          "endDateHomepageTest": "Collect car"
        }
      }
    }
  },
  "sliderSettings": {
    "dots": false,
    "infinite": true,
    "speed": 500,
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "autoplay": true,
    "autoplaySpeed": 5000,
    "pauseOnHover": true
  },
  "carouselSettings": {
    "cropPath": "https://secure.airparks.co.uk/img/q/233/158/100/0/convert/jpg/i/static1.airparks.co.uk/",
    "path": "https://static1.airparks.co.uk"
  },
  "imageCloudSettings": {
    "imageCloudEndpoint": "https://image-cloud-staging.dock-yard.io/fetch",
    "imageCloudEndpointImage": "https://image-cloud-staging.dock-yard.io/image",
    "imageCloudCDN": "https://d1u5bw6boilxum.cloudfront.net",
    "imageCloudWebsite": "airparks.co.uk"
  },
  "loginSettings": {
    "loginErrorMessage": "Incorrect email or password",
    "emailErrMessage": "Please enter your email",
    "sentMagicLinkMessage": "We’ve sent a login email to this address. Please check your inbox."
  },
  "userExists": {
    "url": "https://v2.airparks.co.uk/dock-yard/traveller-api/graphql",
    "query": {
      "query": "query UserExists($email: String!){hasAccount(email: $email)}",
      "variables": {
        "email": ""
      }
    }
  }
};module.exports = config;


// WEBPACK FOOTER //
// ./config/index.js